import { Button, Form, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useNavigation, useSubmit } from "react-router";
import { useForm } from "antd/lib/form/Form";
import FormPage from "./FormPage";

export default function ({ title, form, transformData, loadFn, children }) {
  if (!form) {
    const [f] = useForm();
    form = f;
  }
  const submit = useSubmit();
  const navigation = useNavigation();

  useEffect(() => {
    if (!!loadFn) {
      loadFn(form);
    }
  }, []);

  const onFormFinish = (data) => {
    const transf = transformData ? transformData(data) : data;
    submit(transf, { method: !!loadFn ? "put" : "post", encType: "application/json" });
  };

  return (
    <FormPage title={title} form={form} onFinish={onFormFinish} autoComplete="off">
      {children}
      <Form.Item style={{ textAlign: "end" }} wrapperCol={{ span: 24 }}>
        <Button type="primary" htmlType="submit" loading={navigation.state === "submitting"}>
          Conferma
        </Button>
      </Form.Item>
    </FormPage>
  );
}
